<template>
  <div class="good-tags">
    <template v-if="goodTags.length">
      <tag
        v-for="(promote, index) in goodTags"
        :key="index"
        has-border
        :has-background="!!promote.backgroundColor"
        :primary-color="promote.textColor"
        :secondary-color="promote.frameColor"
        :corner-radius="promote.cornerRadius"
        :bg-color="promote.backgroundColor"
      >
        {{ promote.tag }}
      </tag>
    </template>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'
export default {
  components: {
    Tag
  },
  props: {
    goodTags: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.good-tags {
  height: 0.4rem;
  margin-top: 0.08rem;
  padding-top: 2px;
  overflow: hidden;

  @include flex(row, flex-start, flex-start, wrap);

  ::v-deep .good-tag {
    margin: 0 5px 5px 0;

    flex: none;
  }

  ::v-deep .member-price {
    margin: 0 5px 5px 0;

    flex: none;
  }
}
</style>
